import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchAdminById, updateAdmin } from "../../services/apiServices";
import {
  Button,
  Input,
  Label,
  Card,
  CardBody,
  CardHeader,
  Spinner,
  Alert,
  Form,
  FormGroup,
} from "reactstrap";
import { toast } from "react-toastify";

const EditAdmin = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({ name: "", email: "", role: "admin" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const getAdmin = async () => {
      try {
        setLoading(true);
        const res = await fetchAdminById(id);
        const adminData = res?.data?.data || res?.data || res;
        setForm({
          name: adminData.name || "",
          email: adminData.email || "",
          role: adminData.role || "admin",
        });
      } catch (err) {
        console.error(err);
        setError("Failed to load admin data");
      } finally {
        setLoading(false);
      }
    };

    getAdmin();
  }, [id]);

  const handleSubmit = async () => {
    try {
      await updateAdmin(id, form);
      toast.success("Admin updated successfully!");
      navigate(-1);
    } catch (err) {
      console.error(err);
      toast.error("Update failed. Please try again.");
    }
  };

  if (loading) {
    return (
      <div className="text-center p-4">
        <Spinner color="primary" />
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }

  return (
    <div className="page-content d-flex justify-content-center">
      <Card className="shadow-sm w-50">
        <CardHeader className="d-flex justify-content-between align-items-center bg-primary text-white">
          <h5 className="mb-0">Edit Admin</h5>
          <Button color="secondary" size="sm" onClick={() => navigate(-1)}>
            Back
          </Button>
        </CardHeader>
        <CardBody>
          <Form>
            <FormGroup>
              <Label for="name">Name</Label>
              <Input
                id="name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Enter name"
              />
            </FormGroup>

            <FormGroup className="mt-3">
              <Label for="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="Enter email"
              />
            </FormGroup>

            <FormGroup className="mt-3">
              <Label for="role">Role</Label>
              <Input
                type="select"
                id="role"
                value={form.role}
                onChange={(e) => setForm({ ...form, role: e.target.value })}>
                <option value="admin">Admin</option>
                <option value="superadmin">Super Admin</option>
              </Input>
            </FormGroup>

            <div className="d-flex justify-content-end mt-4">
              <Button color="primary" onClick={handleSubmit}>
                Update Admin
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default EditAdmin;
